const Carousel = (selector, options = {}) => {

    if (document.querySelectorAll(selector).length > 0) {
        import(
            /* webpackChunkName: "carousel" */
            "./carousel"
        ).then(({ default: CarouselInstance }) => {
            new CarouselInstance(selector, options);
        });
    }

};

export default Carousel;